import React from 'react';
import { Helmet } from 'react-helmet-async';
import { clientContent } from '../../client/content';
import styles from './Contact.module.scss';

const Contact: React.FC = () => {
  const { title, description, canonical } = clientContent.seo.contact;
  const { title: pageTitle, subtitle, badge, footerNote } = clientContent.contact;
  const { contactEmail, businessName } = clientContent;
  const mailtoHref = `mailto:${contactEmail}?subject=${encodeURIComponent('Project Enquiry')}&body=${encodeURIComponent(`Hi ${businessName},\n\nI would like to discuss a website for my business.\n\nBusiness Name:\nWhat we do:\nWhat we need:\n\nBest regards,`)}`;

  return (
    <div className={styles.contactWrapper} data-testid="contact-page">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
      </Helmet>

      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className="container">
          <span className={styles.badge}>{badge}</span>
          <h1 className={styles.heading}>{pageTitle}</h1>
          <p className={styles.subheading}>
            {subtitle}
          </p>

          <div className={styles.contactBox}>
            <div className={styles.emailDisplay}>
              <span className={styles.emailLabel}>Direct Email Address</span>
              <a href={mailtoHref} className={styles.emailAddress}>
                {contactEmail}
              </a>
            </div>

            <div className={styles.buttonContainer}>
              <a href={mailtoHref} className={styles.emailButton}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                Email us
              </a>
            </div>

            <p className={styles.footerNote}>
              {footerNote}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
